module.exports = __webpack_public_path__ + "img/fanta.626e545d.jpg";